import DefaultEditor from '@/components/form/DefaultEditor'
import { Box, Grid, Typography } from '@mui/material'
import * as React from 'react'
import { useEffect } from 'react'
import {
    Create,
    required,
    SaveButton,
    SelectInput,
    SimpleForm,
    TextInput,
    Toolbar,
    useNotify,
    useCreateController
} from 'react-admin'

export default function ConsentPurposeCreate() {
    useEffect(() => {
        document.title = 'Nouvel usage RGPD'
    }, [])

    return (
        <Create
            title="Créer un nouvel usage RGPD"
            redirect="list"
        >
            <SimpleForm
                warnWhenUnsavedChanges
                noValidate
                toolbar={<FormToolbar />}
                sx={{
                    padding: {
                        md: '32px',
                        xs: '16px'
                    }
                }}
            >
                <Grid container display={{ xs: 'block', md: 'flex' }} sx={{ gap: '30px', justifyContent: 'space-between' }}>
                    <Grid item xs={12} md={5}>
                        <Typography variant="h6" gutterBottom>
                            Informations générales
                        </Typography>

                        <TextInput
                            source="code"
                            label="Code"
                            helperText="Code unique pour identifier l'usage (ex: marketing_emails)"
                            fullWidth
                            validate={req}
                        />

                        <TextInput
                            source="title"
                            label="Titre"
                            helperText="Titre affiché à l'utilisateur"
                            fullWidth
                            validate={req}
                        />

                        <SelectInput
                            source="version_type"
                            label="Type de version"
                            choices={[
                                { id: 'MINOR', name: 'Version mineure (MINOR) - Changements non critiques' },
                                { id: 'MAJOR', name: 'Version majeure (MAJOR) - Changements importants' }
                            ]}
                            defaultValue="MINOR"
                            helperText="Une version majeure révoque automatiquement les consentements existants"
                            fullWidth
                            validate={req}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Typography variant="h6" gutterBottom>
                            Informations complémentaires
                        </Typography>
                        
                        <Box sx={{ mt: 2, p: 2, backgroundColor: 'action.hover', borderRadius: 1 }}>
                            <Typography variant="body2" color="textSecondary">
                                <strong>Note :</strong> Le numéro de version sera généré automatiquement selon le type choisi.
                                L'usage sera créé en statut actif par défaut.
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>

                <Box sx={{ mt: 3 }}>
                    <DefaultEditor
                        source="description"
                        label="Description détaillée"
                    />
                    <Typography variant="caption" color="textSecondary" sx={{ mt: 1, display: 'block' }}>
                        Description complète de l'usage qui sera affichée aux utilisateurs lors du consentement
                    </Typography>
                </Box>
            </SimpleForm>
        </Create>
    )
}

const req = [required()]

const FormToolbar = () => {
    const notify = useNotify()

    return (
        <Toolbar className="fixed-bottom" sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <SaveButton alwaysEnable className="save" label="Créer l'usage" />
        </Toolbar>
    )
}